/* eslint-disable @typescript-eslint/no-unused-vars */
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import CustomReport from "./customReport";

const eventBreadcrumbs: Array<PageLink> = [
  {
    title: "Custom Report",
    path: "/customReport",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const CustomReportPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={eventBreadcrumbs}>Custom Report</PageTitle>
      <Routes>
        <Route path="/" element={<CustomReport />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default CustomReportPage;
